import * as React from 'react';

import ContentCard from 'components/cards/content-card/ContentCard';

import { __t, applyTranslations } from 'utils/language';

import './performance-card.scss';

import type {
  ContentCard as ContentCardType
} from 'components/cards/content-card/types';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./shared/performance-card-shared.i18n.json'));

type Props = {
  value: string,
  valueType: 'highest' | 'lowest',
  metricType: string,
  contentCard: ContentCardType,
  onNoPostClick: () => void
};

const COMMON_MSG_KEY = 'collabary_common';
const MSG_KEY = 'performance_card_shared';

const PerformanceCard = ({
  value,
  valueType,
  metricType,
  contentCard,
  onNoPostClick
}: Props): JSX.Element => (
  <div className="performance-card">
    <div className="performance-card__stats">
      <div className="performance-card__label">
        {__t(`${MSG_KEY}.labels.${valueType}`)}
      </div>
      <div className="performance-card__value">
        {value}
      </div>
      <div className="performance-card__metric-type">
        {__t(`${COMMON_MSG_KEY}.kpis.${metricType}`)}
      </div>
    </div>
    <ContentCard
      {...contentCard}
      suppressBoxShadow
      onNoPostClick={onNoPostClick}
    />
  </div>
);

export default PerformanceCard;
